























































































import {Component, Vue, Watch} from 'vue-property-decorator';
import WorkstationView, {FlowDirection} from '@/components/WorkstationView.vue';
import {VueContext} from 'vue-context';
import {ProductionLine} from '@/classes/ProductionLine';
import {DiceFactory} from '@/classes/DiceFactory';
import SimulationCharter from '@/components/SimulationCharter.vue';

@Component({components: {SimulationCharter, WorkstationView, VueContext}})
export default class ProductionLineView extends Vue {
    protected contextStation: number = 0;
    protected isBusy: boolean = false;
    protected scale: number = 100;
    protected animationMultiplier: number = 0.5;
    protected productionLine: ProductionLine = new ProductionLine(new DiceFactory());

    @Watch('animationMultiplier')
    protected onAnimationMultiplierChanged(): void {
        this.productionLine.setWaitMultiplier(this.animationMultiplier);
    }

    @Watch('scale')
    protected onScaleChanged(): void {
        document.documentElement.style.setProperty('--scale', `${this.scale / 100}`);
    }

    protected async work(numberOfDays: number = 1): Promise<void> {
        this.isBusy = true;
        for (let i = 0; i < numberOfDays; i++) {
            await this.productionLine.work();
        }
        this.isBusy = false;
    }

    protected async demonstrateSolo(): Promise<void> {
        const NUMBER_OF_DAYS: number = 20;

        this.productionLine.restart();
        await this.speedUpCallback(async () => {
            await this.work(NUMBER_OF_DAYS);
        });
        this.showStatisticsChart();
    }

    protected showStatisticsChart(): void {
        this.$modal.show('chart-modal');
    }

    protected async demonstrateMobbing(): Promise<void> {
        await this.speedUpCallback(async () => {
            this.isBusy = true;
            await this.productionLine.mob();
            this.isBusy = false;
        });
        this.showStatisticsChart();
    }

    protected async speedUpCallback(callback: any): Promise<void> {
        const originalAnimationMultiplier: number = this.animationMultiplier;
        if (this.animationMultiplier > 0.1) {
            this.animationMultiplier = 0.1;
        }

        await callback();

        this.animationMultiplier = originalAnimationMultiplier;
    }

    protected getFlowDirectionOfStation(stationId: number): FlowDirection {
        if ([0, 1, 2, 3].includes(stationId)) {
            return FlowDirection.LeftToRight;
        }

        if ([4, 5].includes(stationId)) {
            return FlowDirection.TopToBottom;
        }

        return FlowDirection.RightToLeft;
    }

    protected onDragDrop({sourceId, destinationId}: any): void {
        this.productionLine.moveWorker(sourceId, destinationId);
    }

    protected openContextForStation(event: any, stationId: number): void {
        this.contextStation = stationId;
        // @ts-ignore;
        return this.$refs.menu.open(event);
    }

    protected moveAllWorkersToContextStation() {
        this.productionLine.moveAllWorkersTo(this.contextStation);
    }

    private created(): void {
        this.productionLine.setWaitMultiplier(this.animationMultiplier);
    }
}
